import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Clipboard } from 'ts-clipboard';
import * as moment from 'moment/moment';

import { FeedMetadataDetail } from '../shared/models/feed-metadata-detail.model';
import { FeedMetadataService } from '../shared/feed-metadata.service';
import { WindowService } from '../../../shared/window.service';
import { ConfigurationService } from '../../../shared/configuration.service';
import { FeedRssCookieService } from '../shared/feed-rss-cookie.service';
import { FeedRepostNotification } from '../shared/models/feed-repost-notification.model';
import { TimeDurationUnit, } from './../../../shared/timepicker/time-picker-interval';
import { EventLoggerService } from '../../../shared/event-logger.service';
import { ErrorManagerService } from '../../../shared/error-handling/error-manager.service';

@Component({
  selector: 'dm-feed-detail',
  templateUrl: './feed-detail.component.html',
  styleUrls: ['./feed-detail.component.css'],
  providers: [FeedRssCookieService]
})
export class FeedDetailComponent implements OnInit {
  initializing = true;
  feedDetail: FeedMetadataDetail;
  notifications: FeedRepostNotification[] = [];
  registerUrl: string;
  connextUrl: string;
  lastUpdated: string;
  firstAvailable: string;
  showFeedRssPopup = true;
  rssUrl: string;
  hasNotifications = false;
  timeDurationUnit: number;
  error: any;
  errorKey = 'feed-detail';
  showDatasetButton = true;
  feedProductType = 3;
  feedDetailUrl: string;

  constructor(private windowService: WindowService,
    private feedMetadataService: FeedMetadataService,
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
    private feedRssCookieService: FeedRssCookieService,
    private eventLogger: EventLoggerService,
    private errorManager: ErrorManagerService) {

    const configuration = configurationService.configuration;
    this.registerUrl = configuration.registerUrl;
  }

  ngOnInit(): void {
    this.clearError();

    this.route.params
      .switchMap((params: Params) =>
        this.feedMetadataService.get(params['feed'])
      )
      .subscribe(
        ctx => {
          this.feedDetail = ctx;
          this.notifications = this.feedDetail.repostNotifications;
          this.hasNotifications = this.notifications ? this.notifications.length > 0 : this.hasNotifications;
          this.timeDurationUnit = ctx.timeDurationUnit;

          // Note:  toISOString will convert a timezone to UTC, so instead, we let moment convert for us.
          this.lastUpdated = this.getDateString(this.feedDetail.lastDataLoadEst, false, this.timeDurationUnit === TimeDurationUnit.Seconds);
          this.firstAvailable = this.getDateString(this.feedDetail.firstAvailable, true, false);
          this.feedProductType = this.feedDetail.feedProductType;
          const configuration = this.configurationService.configuration;
          const baseSyndicationUrl = configuration.baseSyndicationUrl;
          this.registerUrl = configuration.registerUrl;
          this.connextUrl = configuration.connextUrl;
          this.rssUrl = `${baseSyndicationUrl}/${this.feedDetail.name}/rss`;
          this.feedDetailUrl = `/feed/${this.feedDetail.name}`;
          this.initializing = false;
        },
        error => {
          this.error = error;
          this.handleError(error);
        }
      );

    this.showFeedRssPopup = !this.feedRssCookieService.cookieExists();
  }

  openRss(): void {
    // need to reset here as user may be in same session and already selected to not show popup again.
    this.showFeedRssPopup = !this.feedRssCookieService.cookieExists();
    if (this.showFeedRssPopup) {
      this.windowService.openWindow(`/rss/${this.feedDetail.name}`, 'rssPopup', 408, 211);
    } else {
      Clipboard.copy(this.rssUrl);
    }
  }

  openInstructions(): void {
    this.windowService.openWindow(`/instructions`, 'instructionsPopup', 590, 299);
  }

  getDateString(value: Date, dateOnly: boolean, showSeconds: boolean) {
    if (value) {
      if (!showSeconds) {
        return moment(value).format('M/D/YYYY HH:mm');
      } else {
        return moment(value).format('M/D/YYYY HH:mm:ss');
      }
    }

    return 'N/A';
  }

  clearError() {
    this.errorManager.removeDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey);
  }

  handleError(error: any) {
    const FeedDefinitionNoResponse = 'An unexpected error occurred. Please try again.';
    this.errorManager.saveDataMinerUiError(this.errorManager.errorFeedsListKey, this.errorKey, error, FeedDefinitionNoResponse);
    this.eventLogger.logError(new Error(this.errorManager.dataMinerUiError.message), this.errorManager.dataMinerUiError.message, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-detail/feed-detail.component.ts